import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  ILeadDropForm,
  ICourse,
  IHigherQualification,
  ILeadDropPopup,
  IUniversityDetails,
  UniversityState,
} from "@/types/university";

// Re-export types for backward compatibility
export type {
  ILeadDropForm,
  ICourse,
  IHigherQualification,
  ILeadDropPopup,
  IUniversityDetails,
  UniversityState,
} from "@/types/university";

// Initial state
const initialState: UniversityState = {
  university_1: {
    id: "1",
    name: "",
    uni_code: "",
    source: "",
    desktop_promotional_banner: "",
    mobile_promotional_banner: "",
    mobile_promotional_icon: "",
    promotional_banner_alt: "Promotional banner",
    enable_promotional_banner: false,
    promotional_blink_interval_seconds: "",
    mobile_whatsapp_icon: "",
    mobile_phone_icon: "",
    whatsapp_link: "",
    phone_link: "",
    animation_color: "#000000",
    favicon: "",
    chatbot_provider: "",
    non_verified_media: "",
    non_verified_campaign: "",
    default_sitemap_lastmod: "",
    legal_name: "",
    social_links: "",
    address_street: "",
    address_locality: "",
    address_region: "",
    address_postal_code: "",
    address_country: "",
  },
  course_1: {
    id: "",
    program_name: "",
    // program_value: "",
    erp_unicode: "",
    pok: "",
    priority: 0,
    brochure: "",
  },
  higher_qualification_1: {
    id: "",
    name: "",
    value: "",
    priority: 0,
  },
  lead_drop_form_1: {
    id: "",
    title: "",
    sub_text: "",
    checkbox_description: "",
    button_text: "",
    button_color: "#BE2330",
    button_icon: "",
    button_icon_alt: "Submit",
    button_text_color: "#FFFFFF",
    button_background_color: "#BE2330",
    success_icon: "",
    success_icon_alt: "Success",
    success_title: "",
    success_description: "",
    success_description_text_color: "#000000",
    success_description_color: "#000000",
    success_button_icon: "",
    success_button_icon_alt: "Continue",
    success_button_text_color: "#FFFFFF",
    success_button_background_color: "#BE2330",
  },
  lead_drop_popup_1: {
    id: "",
    form_title: "",
    form_title_color: "#000000",
    form_sub_text: "",
    form_sub_text_color: "#666666",
    checkbox_description: "",
    checkbox_description_color: "#666666",
    button_color: "#BE2330",
    desktop_bg_image: "",
    mobile_bg_image: "",
    bg_image_alt: "Lead drop popup background",
    existing_user_desktop_image: "",
    existing_user_mobile_image: "",
    existing_user_image_alt: "Existing user",
    existing_user_title: "",
    existing_user_description: "",
    existing_user_title_color: "#000000",
    existing_user_description_color: "#666666",
    brochure_desktop_image: "",
    brochure_mobile_image: "",
    brochure_image_alt: "Brochure",
    brochure_title: "",
    brochure_description: "",
    brochure_title_color: "#000000",
    brochure_description_color: "#666666",
    new_user_desktop_image: "",
    new_user_mobile_image: "",
    new_user_image_alt: "New user",
    new_user_title: "",
    new_user_description: "",
    new_user_title_color: "#000000",
    new_user_description_color: "#666666",
    popup_display_interval_1: "",
    popup_display_interval_2: "",
    popup_display_interval_3: "",
    enable_delay_form: false,
    enable_exit_form: false,
  },
};

// Create the slice
const universitySlice = createSlice({
  name: "university",
  initialState,
  reducers: {
    setLeadDropPopup1: (state, action: PayloadAction<ILeadDropPopup>) => {
      state.lead_drop_popup_1 = action.payload;
    },
    setLeadDropForm1: (state, action: PayloadAction<ILeadDropForm>) => {
      state.lead_drop_form_1 = action.payload;
    },
    setCourse1: (state, action: PayloadAction<ICourse>) => {
      state.course_1 = action.payload;
    },
    setHigherQualification1: (state, action: PayloadAction<IHigherQualification>) => {
      state.higher_qualification_1 = action.payload;
    },
    setUniversity1: (state, action: PayloadAction<IUniversityDetails>) => {
      state.university_1 = action.payload;
    },
    resetUniversityState: () => initialState,
  },
});

// Export actions
export const {
  setLeadDropPopup1,
  setLeadDropForm1,
  setCourse1,
  setHigherQualification1,
  setUniversity1,
  resetUniversityState,
} = universitySlice.actions;

// Selectors
export const selectUniversityContent = (state: { university: UniversityState }) =>
  state.university;

// Export reducer
export default universitySlice.reducer;
